const vi = {
  news_flow: {
    latest_update: "Cập nhật mới nhất",
    title: "Tin tức & Sự kiện",
    view_all: "Xem tất cả",
    read_more: "Đọc tiếp",
    back_to_list: "Quay lại danh sách",
    editorial_board: "Ban Quản Lý CCN Tây Bắc Đức Hòa Đông",
    share: "Chia sẻ",
    related_news: "Tin tức liên quan",
    search_placeholder: "Tìm kiếm tin tức...",
    no_results: "Không tìm thấy tin tức nào phù hợp.",
    categories: {
      all: "Tất cả",
      company: "Tin CCN Tây Bắc Đức Hòa Đông",
      market: "Tin tức thị trường",
      event: "Sự kiện",
    },
    blog_title: "Tin tức & Sự kiện",
    blog_subtitle1: "Cập nhật tin tức",
    blog_subtitle2: "CCN Tây Bắc Đức Hòa Đông",
    blog_desc:
      "Nơi cập nhật những thông tin mới nhất về Cụm Công nghiệp Tây Bắc Đức Hòa Đông, tiến độ dự án, cơ hội đầu tư và các sự kiện nổi bật.",
    promo_title: "Đăng ký tư vấn đầu tư",
    promo_desc:
      "Liên hệ ngay để nhận thông tin chi tiết về quỹ đất và ưu đãi đặc biệt dành cho nhà đầu tư.",
    promo_btn: "Liên hệ ngay",
  },
  landingModel: {
    profit: "Lợi nhuận",
    investment: "Đầu tư",
    ownership: "sở hữu",
    or: "hoặc",
    authorized: "được đối tác ủy quyền",
    swipe: "Vuốt ngang để xem mô hình",
    investor: "NHÀ ĐẦU TƯ",
    returnProfit: "Trả lợi tức / hoàn gốc",
    deposit: "Nạp tiền (taybacduchoadong)",
    factory: "Nhà Xưởng",
    others: "Các ngành khác",
    agricultureExport: "Xuất Khẩu Nông sản (Việt Thiên)",
    startupCo: "Cty Startup",
    realEstate: "Bất Động Sản",
  },

  pdfViewer: {
    titleScript: "Tra Cứu",
    titleNormal: "VỊ TRÍ & THÔNG TIN QUY HOẠCH",
    downloadTooltip: "Tải xuống PDF",
    fullscreenTooltip: "Phóng to",
    loadingText: "Đang tải tài liệu...",
  },
  industrialLanding: {
    headlineScript: "Mở",
    headlineLine1: "KHÔNG GIAN",
    headlineLine2: "DẪN TĂNG TRƯỞNG",
    projectName: "CỤM CÔNG NGHIỆP TÂY BẮC ĐỨC HÒA ĐÔNG",
    subText: "TRANG THÔNG TIN CHÍNH THỨC CỦA CHỦ ĐẦU TƯ",
    consult: "ĐĂNG KÝ TƯ VẤN",
    news: {
      titleScript: "THÔNG TIN",
      titleAmp: " & ",
      titleMain: "SỰ KIỆN",
      detailsTitle: "CHI TIẾT TIN TỨC",
    },
  },
  contact: {
    titleScript: "Tư Vấn",
    titleMain: "Đăng Ký",
    subtitle:
      "Đăng Ký Ngay Hôm Nay Để Trở Thành Chủ Nhân Tiên Phong Và Nhận Trọn Bộ Thông Tin Chi Tiết Cùng Chính Sách Ưu Đãi Hấp Dẫn",
    namePlaceholder: "Họ Và Tên *",
    phonePlaceholder: "Số Điện Thoại *",
    contentPlaceholder: "Nội Dung Cần Tư Vấn",
    btnSubmit: "Gửi Đăng Ký",
    btnSending: "Đang gửi...",
    errorSubmit: "Gửi thông tin không thành công",
    errorSystem: "Có lỗi xảy ra, vui lòng thử lại",
    successTitle: "Đăng Ký Thành Công!",
    successDesc:
      "Cảm ơn quý khách đã quan tâm. Chúng tôi sẽ liên hệ lại trong thời gian sớm nhất.",
    btnClose: "Đóng",
  },
};

export default vi;
